// extracted by mini-css-extract-plugin
export var callCard = "_oe-0";
export var callMessageButton = "_oe-1";
export var helpIcon = "_oe-3";
export var helpIconContainer = "_oe-4";
export var verticalDivider = "_oe-2";